























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { ImagePreview } from "vant";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class FeedItem extends Vue {
  @Prop({
    default: () => {
      return null;
    }
  })
  private feed: any; //单个feed的item
  @Prop({
    default: ""
  })
  private parentKind?: string; //feed的总的类型
  @Prop({
    default: 0
  })
  private index!: number; //index

  get feedNameShow() {
    return this.feed.kind === "follow" ? true : false;
  }

  get feedCommentShow() {
    return this.feed.kind === "comment" ? true : false;
  }

  get feedName() {
    return this.feed.kind === "follow" && this.feed.hasOwnProperty("username")
      ? this.feed.username
      : "";
  }

  get feedComment() {
    return this.feed.kind === "comment" && this.feed.hasOwnProperty("comment")
      ? this.feed.comment.content
      : "";
  }

  get feedPicUrl() {
    return this.feed.kind === "follow"
      ? this.feed.profile_pic_url
      : this.feed.image_low;
  }

  get feedSize() {
    return this.parentKind === "collage" ? "small" : "big";
  }

  get feedCircle() {
    return this.feed.kind === "follow" ? "circle" : "quatro";
  }

  get currentPosition() {
    switch (this.index) {
      case 0: {
        return "top-left";
      }
      case 1: {
        return "top-right";
      }
      case 2: {
        return "bottom-left";
      }
      case 3: {
        return "bottom-right";
      }
    }
  }

  private clickPic() {
    console.log("clickPic", [this.feedPicUrl]);
    ImagePreview([this.feedPicUrl]);
  }
}
